import React from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { Row, Col, Input, message, Modal } from 'antd'
import { CreateButton } from '../../../components/AppButton'
import Table from './Table'
import {
  fetchItems,
  changeTable,
  searchTable,
  editSearch,
} from '../../../actions/sellerPointList'
import './index.less'
import Point from './Form'

const { Search } = Input
const storeKey = 'sellerPointList'
const createPath = '/admin/sellers/create'

const isEPO = localStorage.getItem('isEPO') === '1'

class ItemList extends React.Component {
  state = { visibleModal: false, activePoint: { idnum: null } };

  constructor(props, context) {
    super(props, context)
    this.handleTableOnChange = this.handleTableOnChange.bind(this)
    this.handleSearchOnChange = this.handleSearchOnChange.bind(this)
    this.handleSearchOnClick = this.handleSearchOnClick.bind(this)
    this.handleSearchOnCancel = this.handleSearchOnCancel.bind(this)
  }

  componentDidMount() {
    this.fetchItems(true)
    const { isSearching } = this.props
    !isSearching && this.props.editSearch({ search: null })
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.isFetchItemsLoading && nextProps.fetchItemsError) {
      message.error(nextProps.fetchItemsError)
    }
  }

  fetchItems(first) {
    const {
      pagination = {},
      sorter = {},
      search,
      isSearching,
    } = this.props

    const { idnum } = this.props.seller

    this.props.fetchItems({
      current: first ? 1 : pagination.current,
      pageSize: pagination.pageSize,
      sort: sorter.columnKey,
      order: sorter.order,
      search: (isSearching && search) || null,
      sellerId: idnum,
    })
  }

  async handleTableOnChange(pagination, filters, sorter) {
    // console.log(filters, sorter)
    const { columnKey, field, order } = sorter

    await this.props.changeTable({
      pagination,
      filters,
      sorter: {
        columnKey,
        field,
        order,
      },
    })
    this.fetchItems()
  }

  handleSearchOnChange(e) {
    e.preventDefault()
    const search = e.target.value
    this.props.editSearch({ search })
    if (!search) {
      this.props.searchTable({ isSearching: false })
    }
  }

  async handleSearchOnClick() {
    await this.props.searchTable({ isSearching: true })
    await this.props.changeTable({})
    this.fetchItems()
  }

  async handleSearchOnCancel(e) {
    e.preventDefault()
    await this.props.editSearch({ search: null })
    await this.props.searchTable({ isSearching: false })
    await this.props.changeTable({})
    this.fetchItems()
  }

  render() {
    const setActivePoint = (point, visible) => {
      this.setState({ activePoint: point })
      this.setState({ visibleModal: visible })
    }

    return (
      <div>
        <Row type='flex' justify='space-between' style={{ marginBottom: '24px' }}>
          <Col className='search-top'>
            {/* {!isEPO && */}
              <CreateButton
                onClick={() => setActivePoint({ idnum: null }, true)}
              />
            {/* } */}
          </Col>
          <Col className='search-top'>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <Search
                onChange={this.handleSearchOnChange}
                onSearch={this.handleSearchOnClick}
                value={this.props.search}
                enterButton
              />
              {
                this.props.isSearching &&
                <a href='' onClick={this.handleSearchOnCancel} style={{ lineHeight: 1.5, marginLeft: '12px' }}>
                  Отмена
                </a>
              }
            </div>
          </Col>
        </Row>

        <Table
          // key={Math.random()}
          scroll={{ x: 400 }}
          loading={this.props.isFetchItemsLoading}
          dataSource={this.props.items || []}
          pagination={this.props.pagination}
          filters={this.props.filters}
          sorter={this.props.sorter}
          onChange={this.handleTableOnChange}
          setActivePoint={setActivePoint}
        />

        <Modal
          title='Управление заведением'
          visible={this.state.visibleModal}
          footer={[]}
          onCancel={() => setActivePoint({ idnum: null }, false)}
        >
          <Point
            key={this.state.activePoint.idnum}
            point={this.state.activePoint}
            onReload={() => this.fetchItems()}
            type={this.state.activePoint.idnum ? 'edit' : 'create'}
            setActivePoint={setActivePoint}
          />
        </Modal>
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  const {
    items,
    total,
    isFetchItemsLoading,
    pagination = {},
    filters,
    sorter,
    search,
    isSearching,
    fetchItemsError,
  } = state[storeKey]

  !pagination.pageSize && (pagination.pageSize = 12)
  !pagination.current && (pagination.current = 1)
  return {
    items,
    total,
    isFetchItemsLoading,
    pagination,
    filters,
    sorter,
    search,
    isSearching,
    fetchItemsError,
  }
}

const mapDispatchToProps = dispatch => ({
  fetchItems: params => dispatch(fetchItems(params)),
  changeTable: params => dispatch(changeTable(params)),
  editSearch: search => dispatch(editSearch(search)),
  searchTable: search => dispatch(searchTable(search)),
})

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ItemList))



// WEBPACK FOOTER //
// src/containers/SellerForm/PointList/index.jsx